<template>
  <div name="hrms-searchbox-table" class="hrms-searchbox-table clearfix">
    <div :class="[searchboxDisp == true ? 'search-group-wrapper' : 'search-group-wrapper-min']">
      <div ref="searchboxWrapper" class="toggle-wrapper clearfix" @click="toggleSearchboxDisp()">
          <div class="search-ico" :class="{'color-skin' : !searchboxDisp}"><i class="fa fa-search"></i></div>
          <div class="search-label" v-show="searchboxDisp"> {{ labels.button[nowLang].search }} </div>
          <div class="close-ico" v-show="searchboxDisp"><i class="fa fa-times"></i></div>
      </div>
      <div ref="searchboxPanel" class="search-box-panel clearfix" v-show="searchboxDisp">
    		<hrms-search-box
                  v-model="inputSearch"
	                :receivedStore="receivedStore"
	                :nowLang="nowLang"
	                :searchBoxAlias="searchBoxAlias"
                  @setDataRowSearchboxTable="setDataRowIndex(arguments[0])"
                  @setStaappr="staappr = arguments[0]"
                  @setLoadingParentBool="loadingParentBool = arguments[0]"
                  @setPreLoadParentBool="preLoadParentBool = arguments[0]"
                  @clearTableInputSearch="$refs.searchBoxTable.$emit('$clearTableInputSearch')"
                  :callSearchEvent="callSearchEvent"
                  :listFields="listFields" />
      </div>
    </div>

    <div ref="table" class="clearfix" :class="[searchboxDisp == true ? 'table-box-wrapper' : 'table-box-wrapper-full']">
    <div class="panel-control" v-show="!loadingParentBool && !preLoadParentBool">
      <xls-importer v-show="xlsImportDisp"
                    :labelsButton="labels.button[nowLang]"
                    :postImport="postImport"
                    :resultImport="resultImport"
                    :searchIndex="inputSearch"
                    :fileSample="fileSample" />
    </div>
	    <hrms-table :data="data"
                  @setLoadingParentBool="loadingParentBool = arguments[0]"
                  :loadingParentBool="loadingParentBool"
                  :preLoadParentBool="preLoadParentBool"
                  :receivedStore="receivedStore"
                  :columns="columns"
                  :nowLang="nowLang"
                  :maxRowspan="maxRowspan"
                  :columnEvent="columnEvent"
                  :detailEvent="detailEvent"
                  :selectEvent="selectEvent"
                  :searchDisp="searchDisp"
                  :selectRowBool="selectRowBool"
                  :selectBtnDisp="selectBtnDisp"
                  :indexDisp="indexDisp"
                  :approveEvent="approveEvent"
                  :approveBtnDisp="checkApproveBtnDisp()"
                  :approveInlineBtnDisp="approveInlineBtnDisp"
                  :approveRowBool="approveRowBool"
                  :addEvent="addEvent"
                  :editEvent="editEvent"
                  :cancelEvent="cancelEvent"
                  :backEvent="backEvent"
                  :afterDeleteInlineEvent="afterDeleteInlineEvent"
                  :saveInlineEvent="saveInlineEvent"
                  :addInlineEventBool="addInlineEventBool"
                  :editInlineEventBool="editInlineEventBool"
                  :deleteInlineEventBool="deleteInlineEventBool"
                  :rowDisableCondition="rowDisableCondition"
                  :rowClassCondition="rowClassCondition"
                  :deleteInlineBtnDisp="deleteInlineBtnDisp"
                  :deleteInlineBtnDisabledOlds="deleteInlineBtnDisabledOlds"
                  :saveInlineBtnDisp="saveInlineBtnDisp"
                  :confirmSelectBtnDisp="confirmSelectBtnDisp"
                  :summaryLabel="summaryLabel"
                  :pdfExportDisp="pdfExportDisp"
                  :csvExportDisp="csvExportDisp"
                  :sortDisp="searchBoxAlias !== 'approve' && sortDisp"
                  :addPreLoad="addPreLoad"
                  ref="searchBoxTable" />
      <div class="col-md-12 " v-if="!saveInlineBtnDisp && saveBtnSearchBoxTable && !preLoadParentBool && !loadingParentBool">
        <button type="button" class="btn bg-color-skin pull-left" @click="triggerSaveInlineEventBuiltIn()"><i class="fa fa-check-circle"></i>{{ labels.button[nowLang]['save'] }}</button>
      </div>
      <div class="col-md-12 " v-if="confirmSelectBtnDisp && confirmSelectBtnSearchBoxTable && !preLoadParentBool && !loadingParentBool">
        <button type="button" class="btn bg-color-skin pull-left" @click="triggerSelectEventBuiltIn()"><i class="fa fa-check-circle"></i>{{ labels.button[nowLang]['select'] }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import bus from 'assets/js/bus'
import labels from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'
import xlsImporter from 'components/hrmsTableTemplate/xlsImporter'

export default {
  name: 'hrms-searchbox-table',
  data () {
    return {
      dataRow: {},
      loadingParentBool: true,
      preLoadParentBool: this.unLoadBool,
      searchboxDisp: this.searchBoxAlias !== 'approve',
      inputSearch: this.value,
      staappr: this.value.staappr || '',
      labels: labels
    }
  },
  methods: {
    setDataRowIndex (dataRow) {
      this.dataRow = dataRow
      this.$emit('setDataRowIndex', this.dataRow)
    },
    checkApproveBtnDisp () {
      return this.staappr === '' || this.staappr === 'P'
    },
    toggleSearchboxDisp () {
      this.searchboxDisp = !this.searchboxDisp
    },
    triggerSaveInlineEventBuiltIn () {
      let _this = this
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          _this.$refs.searchBoxTable.$emit('$saveInlineEventBuiltIn')
        }
      })
    },
    triggerSelectEventBuiltIn () {
      this.$refs.searchBoxTable.$emit('$selectEventBuiltIn')
    }
  },
  watch: {
    inputSearch (newVal) {
      this.$emit('input', newVal)
    },
    unLoadBool () {
      this.preLoadParentBool = this.unLoadBool
    }
  },
  mounted () {
    this.$on('$searchBoxTableRef', (event) => {
      if (typeof event === 'undefined' || event === 'saveInline') {
        this.$refs.searchBoxTable.$emit('$saveInlineEventBuiltIn')
      } else if (event === 'select') {
        this.$refs.searchBoxTable.$emit('$selectEventBuiltIn')
      }
    })
    bus.$on('veeValidate', () => {
      this.$validator.validateAll().then(result => {
        this.$emit('validateEvent', result)
      }).catch(result => {
        this.$emit('validateEvent', false)
      })
    })
  },
  props: {
    unLoadBool: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      required: true
    },
    receivedStore: {
      type: Function,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    searchBoxAlias: {
      type: String
    },
    nowLang: {
      type: String,
      default: labels.defaultLang
    },
    maxRowspan: {
      type: Number,
      default: 1
    },
    columnEvent: {
      type: Function
    },
    detailEvent: {
      type: Function
    },
    selectEvent: {
      type: Function
    },
    selectRowBool: {
      type: Boolean,
      default: false
    },
    selectBtnDisp: {
      type: Boolean,
      default: false
    },
    indexDisp: {
      type: Boolean,
      default: true
    },
    approveEvent: {
      type: Function
    },
    approveBtnDisp: {
      type: Boolean,
      default: false
    },
    approveInlineBtnDisp: {
      type: Boolean,
      default: true
    },
    approveRowBool: {
      type: Boolean,
      default: false
    },
    addEvent: {
      type: Function
    },
    editEvent: {
      type: Function
    },
    cancelEvent: {
      type: Function
    },
    backEvent: {
      type: Function
    },
    afterDeleteInlineEvent: {
      type: Function
    },
    saveInlineEvent: {
      type: Function
    },
    addInlineEventBool: {
      type: Boolean,
      default: false
    },
    editInlineEventBool: {
      type: Boolean,
      default: false
    },
    deleteInlineEventBool: {
      type: Boolean,
      default: false
    },
    rowDisableCondition: {
      type: Function
    },
    rowClassCondition: {
      type: Function
    },
    deleteInlineBtnDisp: {
      type: Boolean,
      default: true
    },
    deleteInlineBtnDisabledOlds: {
      type: Boolean,
      default: false
    },
    searchDisp: {
      type: Boolean,
      default: true
    },
    saveInlineBtnDisp: {
      type: Boolean,
      default: true
    },
    confirmSelectBtnDisp: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    summaryLabel: {
      type: String,
      default: ''
    },
    pdfExportDisp: {
      type: Boolean,
      default: false
    },
    csvExportDisp: {
      type: Boolean,
      default: false
    },
    xlsImportDisp: {
      type: Boolean,
      default: false
    },
    postImport: {
      type: Function
    },
    resultImport: {
      type: Object
    },
    listFields: {
      type: Object
    },
    saveBtnSearchBoxTable: {
      type: Boolean,
      default: false
    },
    confirmSelectBtnSearchBoxTable: {
      type: Boolean,
      default: false
    },
    callSearchEvent: {
      type: Function
    },
    sortDisp: {
      type: Boolean,
      default: true
    },
    fileSample: {
      type: String
    },
    addPreLoad: {
      type: Boolean,
      defalult: false
    }
  },
  components: {
    xlsImporter
  }
}
</script>

<style lang="scss">

.hrms-searchbox-table {
  width: 100%;
  background: #FFF;
  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
  position: relative;

  @media (max-width: 768px) {
    display: block;
  }

  .search-group-wrapper {
    width: 250px;
    position: absolute;
    animation-name: search-resize-max;
    height: 100%;
    background: #F5F5F5;
    min-height: 800px;
    animation-duration: .4s;

    @media (max-width: 768px) {
      width: 100%;
      float: none;
      display: block;
      position: relative;
      min-height: auto;
      animation-name: none;
    }

    .toggle-wrapper {
      width: 100%;
      background: #F5F5F5;
      padding: 8px 15px 5px 13px;
      color: #757575;
      font-size: 18px;
      cursor: pointer;
      border-bottom: 1px solid #d2d6de;

      .search-ico {
        float: left;
      }

      .search-label {
        float: left;
        font-size: 16px;
        font-weight: 700;
        padding: 1px 0 0 5px;
      }

      .close-ico {
        float: right;
      }
    }
  }
  .search-group-wrapper-min {
    width: 45px;
    float: left;

    @media (max-width: 768px) {
      width: 100%;
      float: none;
      display: block;
    }

    .toggle-wrapper {
      width: 100%;
      padding: 8px 15px 5px 13px;
      color: #757575;
      font-size: 18px;
      cursor: pointer;

      .search-ico {
        float: left;
      }

      .search-label {
        float: left;
        font-size: 16px;
        font-weight: 700;
        padding: 1px 0 0 5px;
      }

      .close-ico {
        float: right;
      }
    }
  }

  .search-box-panel {
    // width: 100%;
    // height: auto;
    // background: #F5F5F5;
    // box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3);
    // min-height: 660px;
    // animation-duration: .4s;

    @media (max-width: 768px) {
      min-height: 0;
      display: block;
    }
  }
  .table-box-wrapper {
    width: 100%;
    padding-left: 250px;
    background: #FFF;
    height: 100%;
    min-height: 800px;

    @media (max-width: 768px) {
      width: 100%;
      padding-left: 0px;
      float: none;
      display: block;
      min-height: 300px;
    }
  }
  .table-box-wrapper-full {
    width: 100%;
    padding-left: 45px;
    background: #FFF;
    height: 100%;
    min-height: 800px;

    @media (max-width: 768px) {
      width: 100%;
      padding-left: 0px;
      float: none;
      display: block;
    }
  }
}

@keyframes search-resize-max {
  0% {
    width: 50px;
  }
  100% {
    width: 250px;
  }
}

</style>



// WEBPACK FOOTER //
// component.vue?0187f7b7